var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shield",class:_vm.large ? 'shield--large' : 'shield--small'},[_c('v-lazy-image',{attrs:{"alt":_vm.altTitle,"src":_vm.src,"src-placeholder":_vm.srcPlaceholder}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }